const RECHARGE_GIFT_POPUP_STORAGE_PREFIX = 'recharge-gift-popup:';

const getRechargeGiftPopupStorageKey = () => {
  const date = new Date();
  const dateKey = `${date.getFullYear()}-${
    date.getMonth() + 1
  }-${date.getDate()}`;
  return `${RECHARGE_GIFT_POPUP_STORAGE_PREFIX}${dateKey}`;
};

export const canShowRechargeGiftPopup = (dailyPopupLimit?: number | null) => {
  const popupCount = Number(
    localStorage.getItem(getRechargeGiftPopupStorageKey()) || 0,
  );
  return popupCount < Math.max(0, dailyPopupLimit ?? 1);
};

export const markRechargeGiftPopupShown = () => {
  const storageKey = getRechargeGiftPopupStorageKey();
  const popupCount = Number(localStorage.getItem(storageKey) || 0);
  localStorage.setItem(storageKey, String(popupCount + 1));
};

export const clearRechargeGiftPopupCount = () => {
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith(RECHARGE_GIFT_POPUP_STORAGE_PREFIX)) {
      localStorage.removeItem(key);
    }
  });
};
